import { render } from "./TrainingBlockComponent.vue?vue&type=template&id=49faec8b&scoped=true"
import script from "./TrainingBlockComponent.vue?vue&type=script&lang=js"
export * from "./TrainingBlockComponent.vue?vue&type=script&lang=js"

import "./TrainingBlockComponent.vue?vue&type=style&index=0&id=49faec8b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49faec8b"]])

export default __exports__